import React, { useEffect, useState } from 'react';

import { Button, ButtonIcon, Flex, Icons, Loading, Page, Typography } from 'components';
import { CenteredLayout } from '../components';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';
import { createUrl } from 'app/utils';
import useEducational from '../useEducational';
import usestorage from 'app/utils/storage';

const ShieldIcon = styled(Icons)`
  width: 20px;
  color: ${({ theme }) => theme.colors.primary_400};
  flex-shrink: 0;
`;

const ArrowIcon = styled(Icons)`
  width: 24px;
  color: ${({ theme }) => theme.colors.white};
`;

const RegisterSuccess = () => {
  const navigate = useNavigate();
  const storage = usestorage('sessionStorage');

  const [loading, setLoading] = useState(true);

  const { activationCode, activatedCode } = useEducational();

  useEffect(() => {
    if (activationCode) {
      setLoading(false);
    } else {
      navigate(createUrl('educational/activate/code'));
    }
  }, [activationCode]);

  if (loading) return <Loading />;

  return (
    <Page title="MELVER nas Escolas">
      {loading && <Loading alpha />}

      <CenteredLayout maxWidth={{ m: '80%', d: 550 }}>
        <Flex flexDirection={'column'} alignItems={'center'} style={{ gap: 20 }}>
          <Typography type="type4" fontWeight="bold">
            Cadastro realizado com sucesso.
          </Typography>

          <Flex flexDirection="column" justifyContent="center" textAlign="center" style={{ gap: 5 }}>
            <Typography>Seu nome de usuário é:</Typography>

            <Typography type="type5" color="primary_400" fontWeight="bold">
              {activatedCode?.activatedUserGeneratedLogin}
            </Typography>
          </Flex>

          {activatedCode?.activatedAsGuardian ? (
            <Flex
              flexGrow={0}
              borderWidth={1}
              borderStyle="solid"
              borderColor="#00BFBE99"
              borderRadius={4}
              bg="#00BFBE0D"
              p={{ m: 2, t: 3 }}
              flexWrap="nowrap"
            >
              <ShieldIcon icon="edit" />

              <Flex flexDirection="column" flexGrow={1} pl={{ m: 2, t: 3 }} style={{ gap: 2 }}>
                <Typography color="primary_400" fontWeight="bold">
                  Atenção!
                </Typography>

                <Typography type="type1" color="gray_600" style={{ textWrap: 'pretty' }}>
                  Você receberá um e-mail com instruções para criar sua senha e finalizar seu cadastro.
                </Typography>
              </Flex>
            </Flex>
          ) : (
            activatedCode?.activatedUserGeneratedPassword && (
              <>
                <Flex flexDirection="column" justifyContent="center" textAlign="center" style={{ gap: 5 }}>
                  <Typography>Sua senha gerada automaticamente e exclusiva é:</Typography>

                  <Typography type="type5" color="primary_400" fontWeight="bold">
                    {activatedCode?.activatedUserGeneratedPassword}
                  </Typography>
                </Flex>

                <ButtonIcon
                  icon="squareEditOutline"
                  label="Quer alterar sua senha?"
                  bg="transparent"
                  color="primary_400"
                  colorHover="primary_200"
                  labelColor="primary_400"
                  labelColorHover="primary_200"
                  fontWeight="regular"
                  labelUnderline
                  onClick={() => {
                    storage.set('userWithPin', activatedCode?.activatedUserGeneratedLogin);
                    navigate(createUrl('forgotPassword'));
                  }}
                />

                <Flex
                  flexGrow={0}
                  borderWidth={1}
                  borderStyle="solid"
                  borderColor="#00BFBE99"
                  borderRadius={4}
                  bg="#00BFBE0D"
                  p={{ m: 2, t: 3 }}
                  flexWrap="nowrap"
                >
                  <ShieldIcon icon="edit" />

                  <Flex flexDirection="column" flexGrow={1} pl={{ m: 2, t: 3 }} style={{ gap: 2 }}>
                    <Typography color="primary_400" fontWeight="bold">
                      Atenção!
                    </Typography>

                    <Typography type="type1" color="gray_600" style={{ textWrap: 'pretty' }}>
                      Anote seu nome de usuário e senha em um lugar seguro para acessar nossa plataforma.
                    </Typography>
                  </Flex>
                </Flex>
              </>
            )
          )}
        </Flex>

        <Flex width={1} justifyContent="center" py={2}>
          <Link to={createUrl('login')}>
            <Button type="submit" py={4} width={1} px={3} color="white" justifyContent="space-between" style={{ gap: 20 }} flexShrink={0}>
              <>Entrar na Plataforma</>
              <ArrowIcon icon="arrowRightThin" />
            </Button>
          </Link>
        </Flex>
      </CenteredLayout>
    </Page>
  );
};

export default RegisterSuccess;
